import { render } from "./ExerciseEditor.vue?vue&type=template&id=5838e6e0&ts=true"
import script from "./ExerciseEditor.vue?vue&type=script&lang=ts"
export * from "./ExerciseEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__